import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0448335a7bcb2fd1066c368c8b6dd47c.jpg"
          alt="Restoration team at work"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d1f35]/85 via-[#0d1f35]/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 bg-[#DC2626] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-6 uppercase tracking-widest">
            <i className="ri-shield-check-fill"></i>
            Certified Professionals
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Fast Response.<br />
            Expert Restoration.<br />
            <span className="text-[#DC2626]">Complete Recovery.</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Available 24/7 for emergency mitigation and restoration services across all property types. Our certified team leverages advanced technology to minimize downtime and preserve your property value.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/emergency-cleanup"
              className="inline-flex items-center justify-center gap-2 bg-[#DC2626] text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-alarm-warning-fill"></i>
              Get Emergency Help
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-white hover:text-[#1E3A5F] transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Services
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mt-14">
            {[
              { value: '24/7', label: 'Emergency Response' },
              { value: '60 min', label: 'Avg. Arrival Time' },
              { value: '5,000+', label: 'Properties Restored' },
              { value: '15+ yrs', label: 'Industry Experience' },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="text-3xl font-extrabold text-white">{stat.value}</p>
                <p className="text-white/60 text-xs mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <p className="text-white/50 text-xs uppercase tracking-widest">Scroll</p>
        <i className="ri-arrow-down-line text-white/50"></i>
      </div>
    </section>
  );
}
